import { types } from 'mobx-state-tree'

import { TBaseActivity } from '../activities/BaseActivity'

interface ActivityFilter {
  id: string
  trackingId: string
  label: string
  selected: boolean
  types: string[]
  internal: boolean
}

export const predefinedFilters: ActivityFilter[] = [
  {
    id: 'message',
    trackingId: 'shipment-activity_feed-filters_message',
    label: 'activity-feed_filters_messages',
    selected: true,
    types: ['message'],
    internal: false,
  },
  {
    id: 'notes',
    trackingId: 'shipment-activity_feed-filters_notes',
    label: 'activity-feed_filters_notes',
    selected: true,
    types: ['communication', 'bookingUpdate', 'changeOperationManager'],
    internal: true,
  },
  {
    id: 'events',
    trackingId: 'shipment-activity_feed-filters_events',
    label: 'activity-feed_filters_events',
    selected: true,
    types: [
      'booking',
      'documentUpload',
      'shipmentUpdate',
      'subscription',
      'companyUserUpdate',
      'manualQuote',
      'productUpdate',
      'bookingRequest',
    ],
    internal: false,
  },
  {
    id: 'transport-plan-updates',
    trackingId: 'shipment-activity_feed-filters_transport_plan_updates',
    label: 'activity-feed_filters_transport-plan-updates',
    selected: true,
    types: ['transportPlanUpdated', 'customsDecisionUpdate', 'customsStatusUpdate'],
    internal: false,
  },
]

export const ActivityFilterModel = types
  .model('ActivityFilterModel', {
    id: types.identifier(types.string),
    label: types.string,
    trackingId: types.string,
    selected: types.optional(types.boolean, true),
    types: types.array(types.string),
    internal: types.optional(types.boolean, true),
  })
  .actions((self) => {
    return {
      toggle() {
        self.selected = !self.selected
      },
    }
  })

type TActivityFilterModel = typeof ActivityFilterModel.Type

export const ActivityFiltersModel = types
  .model('ActivityFilters', {
    filters: types.optional(types.array(ActivityFilterModel), []),
    internal: types.boolean,
  })
  .views((self) => {
    return {
      filter(activities: TBaseActivity[]) {
        const activeFilters = self.filters
          .filter((filter) => filter.selected)
          .reduce((types: string[], filter) => {
            return [...types, ...filter.types.slice()]
          }, [])
        return activities.filter((activity) => {
          return activeFilters.indexOf(activity.type) > -1
        })
      },
      get selectedFilters(): TActivityFilterModel[] {
        return self.filters.filter((activityFilter) => activityFilter.selected)
      },
    }
  })
  .actions((self) => {
    return {
      afterCreate() {
        self.filters.replace(
          predefinedFilters
            .filter((filter) => !filter.internal || filter.internal === self.internal)
            .map((filter) => ActivityFilterModel.create(filter))
        )
      },
      toggleFilter(filterId: string) {
        self.filters.find((filter) => filter.id === filterId)!.toggle()
      },
    }
  })

export type TActivityFiltersModel = typeof ActivityFiltersModel.Type
